import createIcon from '../../createIcon';

/**
 * @component @name DirectionsSubwayFilled
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgMi41QzggMi41IDQgMyA0IDYuNVYxNkM0IDE3LjkzIDUuNTcgMTkuNSA3LjUgMTkuNUw2IDIwLjVWMjEuNUgxOFYyMC41TDE2LjUgMTkuNUMxOC40MyAxOS41IDIwIDE3LjkzIDIwIDE2VjYuNUMyMCAzIDE2LjQyIDIuNSAxMiAyLjVaTTguNSAxNi41QzcuNjcgMTYuNSA3IDE1LjgzIDcgMTVDNyAxNC4xNyA3LjY3IDEzLjUgOC41IDEzLjVDOS4zMyAxMy41IDEwIDE0LjE3IDEwIDE1QzEwIDE1LjgzIDkuMzMgMTYuNSA4LjUgMTYuNVpNMTEgMTAuNUg2VjcuNUgxMVYxMC41Wk0xNS41IDE2LjVDMTQuNjcgMTYuNSAxNCAxNS44MyAxNCAxNUMxNCAxNC4xNyAxNC42NyAxMy41IDE1LjUgMTMuNUMxNi4zMyAxMy41IDE3IDE0LjE3IDE3IDE1QzE3IDE1LjgzIDE2LjMzIDE2LjUgMTUuNSAxNi41Wk0xOCAxMC41SDEzVjcuNUgxOFYxMC41WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const DirectionsSubwayFilled = createIcon('DirectionsSubwayFilled', [
  [
    'path',
    {
      d: 'M12 2.5C8 2.5 4 3 4 6.5V16C4 17.93 5.57 19.5 7.5 19.5L6 20.5V21.5H18V20.5L16.5 19.5C18.43 19.5 20 17.93 20 16V6.5C20 3 16.42 2.5 12 2.5ZM8.5 16.5C7.67 16.5 7 15.83 7 15C7 14.17 7.67 13.5 8.5 13.5C9.33 13.5 10 14.17 10 15C10 15.83 9.33 16.5 8.5 16.5ZM11 10.5H6V7.5H11V10.5ZM15.5 16.5C14.67 16.5 14 15.83 14 15C14 14.17 14.67 13.5 15.5 13.5C16.33 13.5 17 14.17 17 15C17 15.83 16.33 16.5 15.5 16.5ZM18 10.5H13V7.5H18V10.5Z',
      key: 'vocz9l',
    },
  ],
]);

export default DirectionsSubwayFilled;
